import ManaWorld from "../loop/ManaWorld"
import DamagableEntity, { DamagableEntityOptions } from "./DamagableEntity"
import ManaWorldPhysicsWrapper from "./ManaWorldPhysicsWrapper"

export type CastingEntityOptions = { manaWorld?: ManaWorld } & DamagableEntityOptions

export default class CastingEntity extends DamagableEntity {

	manaWorld = undefined as (undefined | ManaWorld)
	private manaWorldPhysicsWrapper = undefined as any

	constructor({ manaWorld = undefined, ...rest }: CastingEntityOptions) {
		super(rest)

		this.setManaWorld(manaWorld)
	}

	setManaWorld(manaWorld: (undefined | ManaWorld)) {
		if (manaWorld) {
			if (this.manaWorldPhysicsWrapper) this.manaWorldPhysicsWrapper.dispose()
			this.manaWorld = manaWorld
			this.manaWorldPhysicsWrapper = new ManaWorldPhysicsWrapper({ manaWorld })
			this.world.add(this.manaWorldPhysicsWrapper)
		}
	}

}